var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbUnderMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1",
    fill: "#b3b3b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9 9.06a2.78 2.78 0 01-.5.11 2.6 2.6 0 01-.4 0 2.69 2.69 0 01-.7-.09 3 3 0 01-.5-.17 2.64 2.64 0 01-.44-.23A3 3 0 015.2 3.8V6L7 7l1.8-1V3.8a3 3 0 01-.44 5.07 3.17 3.17 0 01-.46.19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14a7 7 0 10-7-7 7 7 0 007 7zm.4-1.8v-2H7a4.05 4.05 0 01-.7-.07v2.07a.5.5 0 01-1 0V9.82A4 4 0 014.6 3a1 1 0 011.05-.1 1 1 0 01.55.9v1.61l.8.45.8-.45V3.8A1 1 0 019.4 3a4 4 0 01-1 6.94v2.26a.5.5 0 01-1 0z",
    fillRule: "evenodd"
  })))));
}

export default SvgCustomDnbUnderMaintenance;